import React, {Component} from 'react';
import {getLanguage, getUserProfile} from "../../store/rootReducer";
import {connect} from 'react-redux';
import classNames from 'classnames';
import "./Dashboard.scss"
import HrbTranslate from "../../components/language/HrbTranslate";
import VirtualAssistDashboardSection from "./va/VirtualAssistDashboardSection";
import ExternalLink from "../link/ExternalLink";
import DiyDashboardSection from "./diy/DiyDashboardSection";
import Api from "../../services/api/Api";
import {ApiPaths} from "../../services/api/ApiPaths";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import auth from "../../services/auth/AuthProvider";
import DashboardIntroPanel from "./DashboardIntroPanel";
import DashboardDocumentLinkPanel from './DashboardDocumentLinkPanel.js';
import UrlParamsUtil from '../../services/util/UrlParamsUtil';
import * as languageActions from '../language/ducks/actions';

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      virtualAssistCases: null
    };
    this.isAuthenticatedUser = false;
  }

    componentDidMount() {
        this.isAuthenticatedUser = auth.isAuthenticated();
        if (this.isAuthenticatedUser) {
            Api.get(ApiPaths.VA_GET_CASES).then(
                (response) => {
                    this.setState({
                        virtualAssistCases: response.data,
                        isLoaded: true
                    });
                },
                (error) => {
                    this.setState({
                        isLoaded: true
                    });
                }
            );
        } else {
            this.setState({
                isLoaded: true
            });
        }

        var params = UrlParamsUtil.getQueryParamsFromUrl(this.props);
        if (params.lang && params.lang.toUpperCase() !== this.props.lang) {
            this.props.setLanguage(params.lang.toUpperCase());
        }
    }

  render() {
    if (!this.state.isLoaded) {
      return (
          <div className="hrb-dashboard">
            <LoadingSpinner/>
          </div>
      );
    }

    let dashboardAppSectionsClass = classNames('hrb-dashboard-app-section', {'hrb-dashboard-app-section-va': this.props.userProfile.source === "VA"});

    return (
        <div className="hrb-dashboard">
          <div className="hrb-dashboard-content">

            <DashboardIntroPanel userProfile={this.props.userProfile}/>

            <DashboardDocumentLinkPanel />
            
                <div className={dashboardAppSectionsClass}>
                    <VirtualAssistDashboardSection virtualAssistCases={this.state.virtualAssistCases} />
                    <DiyDashboardSection/>
            </div>

            <div className="hrb-dashboard-book-appointment">
              <HrbTranslate text="dashboard.complete_return_in_person"/>
              <ExternalLink linkKey="links.book_appointment" isNewWindow={true}>
                <HrbTranslate text="dashboard.book_an_appointment"/>
                <i className="la la-angle-right"/>
              </ExternalLink>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state),
    userProfile: getUserProfile(state)
  }
};

const mapDispatchToProps = {
    ...languageActions
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);